/* this file is automatically generated.  edit at your own peril */
/* copyright 2015 Minted LLC.  All rights reserved */
var module; UMD(module, {
  'minted:m': ['M'],
  'minted:template': [],
  'minted:vendor/underscore-1.8.2.min': '_',
})(this, function (m_module, m_template, _) {
var M = m_module.M;

M.Template || (M.Template = {});
M.Template.Community || (M.Template.Community = {});

M.Template.Community.ChallengeGrid = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
/*
   * Copyright (C) 2015 Minted Inc.
   *
   * All Rights Reserved
   *
   * CTAG:COMMUNITY:CHALLENGES
   */
__p+='\n\n<div class="challengeGrid">\n  <div class="challengesHeader">\n    <h1 class="currentChallengesHeader">challenges</h1>\n    <div class="currChallengesSubscribeButton">\n      <a class="button buttonFlat buttonGhost buttonMedium challengeCalSubscribeButton">\n        <span class="buttonLabel">SUBSCRIBE</span>\n        <img class="buttonIcon calendarIconGrey sprite"\n          src="'+
((__t=( M.img_src('/static/images/sprite_placeholder.png') ))==null?'':__t)+
'">\n      </a>\n    </div>\n  </div>\n  <div class="noChallenges emptyStateText">There are no challenges to display.</div>\n</div>\n';
}
return __p;
});

M.Template.Community.ChallengeTile = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
/**
   * Copyright (C) 2015 Minted Inc.
   *
   * All Rights Reserved
   *
   * CTAG:COMMUNITY:CHALLENGES
   */
__p+='\n<a\n';
 if (state != M.Config['ChallengeConfig'].state.setup.id) { 
__p+='\n  href="'+
((__t=( M.html.htmlAttributeEscape(challenge_url) ))==null?'':__t)+
'"\n';
 } 
__p+='\n>\n  <div class="challengeBlock">\n    <div class="challengeInfo">\n      <div class="challengeStatusFlag"><span class="challengeStatusText"></span></div>\n      <div class="challengeName">\n        <h2 class="challengeTitle bm"></h2>\n        <p class="challengeSubtitle"></p>\n      </div>\n      <h4 class="challengeCategory">'+
((__t=( M.html.htmlAttributeEscape(category) ))==null?'':__t)+
'</h4>\n        <button class="button buttonMedium buttonFlat buttonPrimary challengeButton\n      ';
 if (state == M.Config['ChallengeConfig'].state.setup.id) { 
__p+='\n        disabled\n      ';
 } 
__p+='\n        ">GO TO CHALLENGE<span>&#9654;</span>\n      </button>\n    </div>\n  </div>\n</a>\n';
}
return __p;
});

M.Template.Community.Comment = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
/*
* Copyright (C) 2016 Minted Inc.
*
* All Rights Reserved
*
* CTAG:COMMUNITY:CHALLENGES

require("vendor/moment.min.js");
*/
__p+='\n\n  <table>\n    <tbody>\n    ';
 for (var i = 0; i < numberOfResponses; i++) {
__p+='\n      <tr class="comment">\n        <td>\n          <p class="text--tertiary commenterInfo">'+
((__t=( M.html.htmlEscape(this.currentModel[i].get('userName')) ))==null?'':__t)+
' ON '+
((__t=( M.html.htmlEscape(moment.unix(this.currentModel[i].get('createdAtEpochTime')).format("MMM DD, YYYY [AT] hh:mmA")) ))==null?'':__t)+
'</p>\n          <p class="text--light">'+
((__t=( M.html.htmlEscape(this.currentModel[i].get('commentText')) ))==null?'':__t)+
'</p>\n        </td>\n      </tr>\n    ';
 } 
__p+='\n    </tbody>\n  </table>\n';
}
return __p;
});

M.Template.Community.ConfirmActivatePrompt = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
/*
   * Copyright (C) 2014 Minted Inc.
   *
   * All Rights Reserved
   */
__p+='\n\n<p>\n  Are you sure you want to reactivate this product? Reactivating a product will\n  make it available in your Store and other pages on Minted.com.\n</p>\n\n<ul class="inline buttons">\n  <li>\n    <a class="button buttonFlat buttonMedium buttonSecondary\n        cancelButton">cancel\n    </a>\n  </li>\n  <li>\n    <a class="button buttonFlat buttonMedium buttonPrimary\n        continueChangeButton">\n        continue\n    </a>\n  </li>\n</ul>';
}
return __p;
});

M.Template.Community.ConfirmDeactivatePrompt = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
/*
   * Copyright (C) 2014 Minted Inc.
   *
   * All Rights Reserved
   */
__p+='\n\n<p>\n  Are you sure you want to deactivate this product? Deactivating a product will\n  remove it from your Store and other pages on Minted.com. You can reactivate\n  the product from the \'My Projects\' page in the \'Deactivated\' table.\n</p>\n\n<ul class="inline buttons">\n  <li>\n    <a class="button buttonFlat buttonMedium buttonSecondary\n        cancelButton">cancel\n    </a>\n  </li>\n  <li>\n    <a class="button buttonFlat buttonMedium buttonPrimary\n        continueChangeButton">\n        continue\n    </a>\n  </li>\n</ul>';
}
return __p;
});

M.Template.Community.CurateLink = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
/*
   * Copyright (C) 2016 Minted Inc.
   *
   * All Rights Reserved
   *
   * CTAG:COMMUNITY:STORES
   */
__p+='\n\n<div class="curatorLink">\n  <a class="text--action">\n    <img class="sprite curateButton '+
((__t=( M.html.htmlAttributeEscape(statusClass) ))==null?'':__t)+
'"\n    src="/static/images/sprite_placeholder.png"/>\n    <span class="statusText">\n      '+
((__t=( M.html.htmlAttributeEscape(statusText) ))==null?'':__t)+
'\n    </span>\n  </a>\n</div>\n';
}
return __p;
});

M.Template.Community.DesignerAssetsPrompt = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
/*
   * Copyright (C) 2014 Minted Inc.
   *
   * All Rights Reserved
   */
__p+='\n\n<p>\n  Your store overlay is missing images. These images help our\n  customers identify with you as a person.\n</p>\n\n<ul class="inline buttons">\n  <li>\n    <a class="button buttonFlat buttonMedium buttonSecondary\n        remindMeLaterButton">\n      remind me later\n    </a>\n  </li>\n  <li>\n    <a class="button buttonFlat buttonMedium buttonPrimary\n        uploadAssetsButton">\n      upload images\n    </a>\n  </li>\n</ul>';
}
return __p;
});

M.Template.Community.FeedbackGallery = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
/*
* Copyright (C) 2016 Minted Inc.
*
* All Rights Reserved
*
* CTAG:COMMUNITY:CHALLENGES
*/
__p+='\n\n<div class="headerContainer">\n  <div class="text--primary truncate">'+
((__t=( M.html.htmlAttributeEscape(headerText) ))==null?'':__t)+
':\n    <a target="_blank" href="'+
((__t=( M.html.htmlAttributeEscape(designRatingPageUrl) ))==null?'':__t)+
'">\n      '+
((__t=( M.html.htmlAttributeEscape(designName) ))==null?'':__t)+
'\n    </a>\n  </div>\n  <div class="text--quaternary">'+
((__t=( M.html.htmlAttributeEscape(challengeName) ))==null?'':__t)+
'</div>\n</div>\n';
 if (buttonLabel) { 
__p+='\n<button class="buttonFlat buttonGhost buttonMedium secondaryActionButton">\n  '+
((__t=( M.html.htmlAttributeEscape(buttonLabel) ))==null?'':__t)+
'\n</button>\n';
 } 
__p+='\n<div class="activityCalloutContainer">\n  <div class="designerInfoContainer"></div>\n  <div class="calloutTextContainer">\n    <div class="calloutLarge">\n      '+
((__t=( M.html.htmlAttributeEscape(feedbackRequestMsg) ))==null?'':__t)+
'\n    </div>\n  </div>\n</div>\n<div class="mainContents clearFix">\n  <div class="designImageContainer">\n    <img src="'+
((__t=( M.html.htmlAttributeEscape(designThumbnail) ))==null?'':__t)+
'" />\n  </div>\n  <div class="sideContainerPanel">\n    <div class="communityCommentContainer"></div>\n    <p class="text--tertiary commentsTitle">MOST RECENT COMMENTS</p>\n    <div class="commentsContainer"></div>\n  </div>\n</div>\n</div>\n';
}
return __p;
});

M.Template.Community.MyProjectsExclusivePrompt = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
/*
   * Copyright (C) 2014 Minted Inc.
   *
   * All Rights Reserved
   */
__p+='\n\n<p>\nYou self-launched this product as exclusive to Minted. Please contact\ndesigners@minted.com to make any changes to this product.\n</p>\n\n  <ul class="inline buttons">\n    <li>\n      <a class="button buttonFlat buttonMedium buttonSecondary\n          cancelButton">close\n      </a>\n    </li>\n  </ul>';
}
return __p;
});

M.Template.Community.OptInExclusivePrompt = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
/*
   * Copyright (C) 2014 Minted Inc.
   *
   * All Rights Reserved
   *
   * CTAG:COMMUNITY:PRODUCT_LAUNCH
   */
__p+='\n\n<p>\n  Please confirm that you\'d like to make this product exclusive to Minted.\n  Once a piece is made exclusive, you will not be able to remove it from your\n  Minted Store, or decide to later make it non-exclusive.\n</p>\n\n<ul class="inline buttons">\n  <li>\n    <a class="button buttonFlat buttonMedium buttonSecondary\n        cancelButton">cancel\n    </a>\n  </li>\n  <li>\n    <a class="button buttonFlat buttonMedium buttonPrimary\n        continueChangeButton">\n        confirm\n    </a>\n  </li>\n</ul>\n';
}
return __p;
});

M.Template.Community.SubmitComment = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
/*
   * Copyright (C) 2015 Minted Inc.
   *
   * All Rights Reserved
   *
   * CTAG:COMMUNITY:CHALLENGES
   */
__p+='\n<p class="text--light">Leave feedback for the artist:</p>\n<textarea class="commentInput"></textarea>\n<button class="submitCommentButton buttonFlat buttonMedium buttonGhost">\n  SUBMIT\n</button>';
}
return __p;
});

M.Template.Community.UserResponseWidget = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
/*
   * Copyright (C) 2015 Minted Inc.
   *
   * All Rights Reserved
   *
   * CTAG:COMMUNITY:CHALLENGES
   */
__p+='\n\n<div class="headerContainer">\n  <div class="text--primary truncate">'+
((__t=( M.html.htmlAttributeEscape(headerText) ))==null?'':__t)+
':\n    <a target="_blank" href="'+
((__t=( M.html.htmlAttributeEscape(itemUrl) ))==null?'':__t)+
'">\n      '+
((__t=( M.html.htmlAttributeEscape(itemName) ))==null?'':__t)+
'\n    </a>\n  </div>\n  <div class="text--quaternary">'+
((__t=( M.html.htmlAttributeEscape(subtitleText) ))==null?'':__t)+
'</div>\n</div>\n';
 if (buttonLabel) { 
__p+='\n  <button class="buttonFlat buttonGhost buttonMedium secondaryActionButton">\n    '+
((__t=( M.html.htmlAttributeEscape(buttonLabel) ))==null?'':__t)+
'\n  </button>\n';
 } 
__p+='\n<div class="activityCalloutContainer">\n  <div class="userInfoContainer floatL verticalCenter"></div>\n  <div class="calloutTextContainer floatL verticalCenter">\n    <div class="calloutLarge floatL">Which design do you prefer?</div>\n    <div class="text--quaternary responseCount floatR">\n      '+
((__t=( M.html.htmlAttributeEscape(responseCount) ))==null?'':__t)+
' responses</div>\n  </div>\n</div>\n<div class="mainContents clearFix"></div>\n<div class="secondaryContents clearFix">\n  <div class="userContents floatL">\n    ';
 if (secondaryHeaderText) { 
__p+='\n      <div class="text--quaternary">\n        '+
((__t=( M.html.htmlAttributeEscape(secondaryHeaderText) ))==null?'':__t)+
'\n      </div>\n    ';
 } 
__p+='\n    <div class="bm text--tertiary">\n      <a target="_blank" class="itemUrl"></a>\n    </div>\n    <div class="userInfoContainer"></div>\n  </div>\n  <div class="designContents"></div>\n  <div class="communityCommentContainer"></div>\n</div>\n';
}
return __p;
});

M.Template.Community.UserTermsAgreement = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
/*
   * Copyright (C) 2014 Minted Inc.
   *
   * All Rights Reserved
   */
__p+='\n\n<div style="margin:0 auto;width:580px;height:250px;overflow:auto;background-color:white;border:1px solid #CCC;padding:10px;">\n  '+
((__t=( nodeContent ))==null?'':__t)+
'\n</div>\n<ul class="inline buttons">\n  ';
 if (showReviewLaterButton) { 
__p+='\n    <li><a class="button buttonFlat buttonMedium buttonSecondary reviewLaterButton">Review Later</a></li>\n  ';
 } 
__p+='\n  <li><a class="button buttonFlat buttonMedium buttonPrimary agreeButton">I Agree</a></li>\n</ul>\n';
}
return __p;
});

M.Template.Community.WithdrawExclusivePrompt = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
/*
   * Copyright (C) 2014 Minted Inc.
   *
   * All Rights Reserved
   */
__p+='\n\n<p>\n  You self-launched this product as exclusive to Minted. Please contact\n  designers@minted.com to make any changes to this product.\n</p>\n\n<ul class="inline buttons">\n  <li>\n    <a class="button buttonFlat buttonMedium buttonSecondary\n        cancelButton">close\n    </a>\n  </li>\n</ul>';
}
return __p;
});


return {};

});
/* end templito generated file */
